import React, { Component } from "react";
import Bridge from "../../utils/Bridge";
import { Spin, Collapse, message } from "antd";
import { FaEye } from "react-icons/fa";
import moment from "moment";
import { Link } from "react-router-dom";

const items = [
  {
    key: "1",
    label: "What is the ECAS score?",
    children: (
      <p>
        The ECAS (Edinburgh Cognitive and Behavioral ALS Screen) is a
        comprehensive assessment tool designed to evaluate cognitive and
        behavioral function in individuals with ALS (amyotrophic lateral
        sclerosis). It helps healthcare providers track changes in cognition and
        behavior over time.
      </p>
    ),
  },
  {
    key: "2",
    label: "What does each section of the ECAS score evaluate?",
    children: (
      <p>
        The ECAS consists of several sections that assess different aspects of
        cognitive and behavioral function, including: Cognitive Function: This
        includes tests for memory, language, attention, and executive function
        (e.g., problem-solving, planning).Behavioral Symptoms: This section
        evaluates emotional and behavioral changes such as apathy,
        disinhibition, and other mood or personality changes commonly associated
        with ALS.
      </p>
    ),
  },
  {
    key: "3",
    label: "My scores differ from session to session, what does this mean?",
    children: (
      <p>
        Variations in your ECAS scores from session to session can occur for
        several reasons, such as differences in mood, fatigue, attention, or
        even the time of day the assessment is administered. It’s important to
        remember that the ECAS score is a snapshot of cognitive and behavioral
        function at a specific point in time, and small fluctuations are not
        uncommon. If you have concerns about significant changes in your scores,
        it’s best to discuss them with your neurologist for a more detailed
        evaluation.
      </p>
    ),
  },
];

export default class PhysicalECASForms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ecas_form_a_list: [],
      ecas_form_b_list: [],
      ecas_form_c_list: [],
      ecas_form_list:[],
      loading: false,
      all_forms:[],
      ecas_user_type:""
    };
    this.topScrollRef = React.createRef();
    this.bottomScrollRef = React.createRef();
  }
  componentDidMount() {
    this.get_ecas_form_list();
  }
  get_ecas_form_list = () => {
    this.setState({ loading: true });
    let params =
    "?participants_id=" + localStorage.getItem("ap_id")+
    "&eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.personal_data_viewer.ecas_study
      .get_ecas_form_list(params)
      .then((res) => {
        if (res.status == "1") {

          let all_form_arr=[]
          for(let item of res.data.ecas_form_list){
            item.form_submission_date=item.submitted_date
            item.sort_date=item.submitted_date
            item.remark='In Clinic'
            item.type='physical'

            item.total=Number(item.executive_score ? item.executive_score: 0)+
            Number(item.langauge_score ? item.langauge_score: 0)+
            Number(item.memory_score ? item.memory_score: 0)+
            Number(item.verbal_fluency_score ? item.verbal_fluency_score: 0)+
            Number(item.visuospatial_score ? item.visuospatial_score: 0)

            all_form_arr.push(item)
          }

          let form_a_arr=[];
          for(let item of res.data.ecas_form_a_list){
            let new_date=item.submitted_date.split(',')[0]
            let date = moment(new_date, "Do MMM YYYY").format("MM/DD/YYYY"); 
            
            let cleanedDate = item.submitted_date.replace(/(\d+)(st|nd|rd|th)/, '$1');

            // Parse and format using moment
            let formattedDate = moment(cleanedDate, "D MMM YYYY, h:mm:ss A").format("YYYY-MM-DD hh:mm:ss A");

            item.sort_date=formattedDate 
            item.form_submission_date=date            
            item.remark=''
            item.type='form-a'
            item.form_type='Form A'

            item.remark='Digital'

            item.langauge_score=Number(item.written_picture_score) +
            Number(item.spelling_score) +
            Number(item.language_comprehension_score)

            item.verbal_fluency_score=Number(item.fluency_ls_score) +
            Number(item.fluency_lt_score)

            item.executive_score=Number(item.reverse_digit_span_score) +
            Number(item.executive_alternation_score) +
            Number(item.sentence_completion_score) +
            Number(item.social_congnition_score)

            item.memory_score= Number(item.recall_score) +
            Number(item.delayed_recall_score) +
            Number(item.delayed_congniation_total_score);

            item.visuospatial_score =Number(item.dot_countring_score) +
            Number(item.cube_countring_score) +
            Number(item.number_location_score)  
            
            item.total=Number(item.written_picture_score) +
            Number(item.spelling_score) +
            Number(item.language_comprehension_score)+
            Number(item.fluency_ls_score) +
            Number(item.fluency_lt_score)+
            Number(item.reverse_digit_span_score) +
            Number(item.executive_alternation_score) +
            Number(item.sentence_completion_score) +
            Number(item.social_congnition_score)+
            Number(item.recall_score) +
            Number(item.delayed_recall_score) +
            Number(item.delayed_congniation_total_score)+
            Number(item.dot_countring_score) +
            Number(item.cube_countring_score) +
            Number(item.number_location_score)  

            form_a_arr.push(item)
          }

          let form_b_arr=[];
          for(let item of res.data.ecas_form_b_list){
            let new_date=item.submitted_date.split(',')[0]
            let date = moment(new_date, "Do MMM YYYY").format("MM/DD/YYYY");            
            item.form_submission_date=date
            item.remark=''
            item.type='form-b'
            item.form_type='Form B'
            item.remark='Digital'

            let cleanedDate = item.submitted_date.replace(/(\d+)(st|nd|rd|th)/, '$1');

            // Parse and format using moment
            let formattedDate = moment(cleanedDate, "D MMM YYYY, h:mm:ss A").format("YYYY-MM-DD hh:mm:ss A");

            item.sort_date=formattedDate 

            item.langauge_score=Number(item.written_picture_score) +
            Number(item.spelling_score) +
            Number(item.language_comprehension_score)

            item.verbal_fluency_score=Number(item.fluency_ls_score) +
            Number(item.fluency_lt_score)

            item.executive_score=Number(item.reverse_digit_span_score) +
            Number(item.executive_alternation_score) +
            Number(item.sentence_completion_score) +
            Number(item.social_congnition_score)

            item.memory_score= Number(item.recall_score) +
            Number(item.delayed_recall_score) +
            Number(item.delayed_congniation_total_score);

            item.visuospatial_score =Number(item.dot_countring_score) +
            Number(item.cube_countring_score) +
            Number(item.number_location_score)  
            
            item.total=Number(item.written_picture_score) +
            Number(item.spelling_score) +
            Number(item.language_comprehension_score)+
            Number(item.fluency_ls_score) +
            Number(item.fluency_lt_score)+
            Number(item.reverse_digit_span_score) +
            Number(item.executive_alternation_score) +
            Number(item.sentence_completion_score) +
            Number(item.social_congnition_score)+
            Number(item.recall_score) +
            Number(item.delayed_recall_score) +
            Number(item.delayed_congniation_total_score)+
            Number(item.dot_countring_score) +
            Number(item.cube_countring_score) +
            Number(item.number_location_score)  

            form_b_arr.push(item)
          }

          let form_c_arr=[];
          for(let item of res.data.ecas_form_c_list){
            let new_date=item.submitted_date.split(',')[0]
            let date = moment(new_date, "Do MMM YYYY").format("MM/DD/YYYY");            
            item.form_submission_date=date
            item.remark=''
            item.type='form-c'
            item.form_type='Form C'
            item.remark='Digital'

            let cleanedDate = item.submitted_date.replace(/(\d+)(st|nd|rd|th)/, '$1');

            // Parse and format using moment
            let formattedDate = moment(cleanedDate, "D MMM YYYY, h:mm:ss A").format("YYYY-MM-DD hh:mm:ss A");

            item.sort_date=formattedDate 

            item.langauge_score=Number(item.written_picture_score) +
            Number(item.spelling_score) +
            Number(item.language_comprehension_score)

            item.verbal_fluency_score=Number(item.fluency_ls_score) +
            Number(item.fluency_lt_score)

            item.executive_score=Number(item.reverse_digit_span_score) +
            Number(item.executive_alternation_score) +
            Number(item.sentence_completion_score) +
            Number(item.social_congnition_score)

            item.memory_score= Number(item.recall_score) +
            Number(item.delayed_recall_score) +
            Number(item.delayed_congniation_total_score);

            item.visuospatial_score =Number(item.dot_countring_score) +
            Number(item.cube_countring_score) +
            Number(item.number_location_score)  
            
            item.total=Number(item.written_picture_score) +
            Number(item.spelling_score) +
            Number(item.language_comprehension_score)+
            Number(item.fluency_ls_score) +
            Number(item.fluency_lt_score)+
            Number(item.reverse_digit_span_score) +
            Number(item.executive_alternation_score) +
            Number(item.sentence_completion_score) +
            Number(item.social_congnition_score)+
            Number(item.recall_score) +
            Number(item.delayed_recall_score) +
            Number(item.delayed_congniation_total_score)+
            Number(item.dot_countring_score) +
            Number(item.cube_countring_score) +
            Number(item.number_location_score)  

            form_c_arr.push(item)
          }

          let all_forms=all_form_arr.concat(form_a_arr,form_b_arr,form_c_arr);
          
          all_forms=all_forms.sort((a, b) => new Date(b.sort_date) - new Date(a.sort_date));
          this.setState({
            all_forms: all_forms,
            ecas_user_type: res.data.ecas_user_type
          });
        }
        this.setState({ loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };
  onChange = (key) => {
  };
  view_file=(item,_single,file)=>{
    let params={
      physical_ecas_form_id:item.physical_ecas_form_id,
      is_single:_single,
      file: file
    }
    Bridge.personal_data_viewer.ecas_study.get_physical_ecas_form_url(params).then((res)=>{
      if(res.status==1){
        window.open(res.data,'_blank')
        return;
      }else{
        message.warning(res.message)
      }
    })
  }
  isJSON=(str) =>{
    try {
      const parsed = JSON.parse(str);
      return Array.isArray(parsed); // true if it's a JSON array
    } catch (e) {
      return false; // Not valid JSON
    }
  }
  handleTopScroll = (e) => {
    if (this.bottomScrollRef.current) {
      this.bottomScrollRef.current.scrollLeft = e.target.scrollLeft;
    }
  }
  handleBottomScroll = (e) => {
    if (this.topScrollRef.current) {
      this.topScrollRef.current.scrollLeft = e.target.scrollLeft;
    }
  }
  render() {
    return (
      <div
        className="als_frs_sessions"
        style={{ overflowY: "visible", maxHeight: "fit-content" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 px-0">
              <Spin spinning={this.state.loading}>
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <h5 className="mb-0">ECAS Form List</h5>
                  <a
                    href="/add-physical-ecas-form"
                    style={{ padding:"5px 20px" }}
                    className="red_big_button d-flex align-items-center"
                  >
                  <box-icon 
                    name="plus"
                    color="#fff"
                    size={'27px'}
                    style={{position:'relative',top:0,left:-3 }}
                  ></box-icon> Upload ECAS Form
                  </a>
                </div>
                <style>
                  {`
                    .top-scrollbar::-webkit-scrollbar {
                      height: 6px;
                    }
                    .top-scrollbar::-webkit-scrollbar-track {
                      background: #f1f1f1;
                      border-radius: 3px;
                    }
                    .top-scrollbar::-webkit-scrollbar-thumb {
                      background: #c1c1c1;
                      border-radius: 3px;
                    }
                    .top-scrollbar::-webkit-scrollbar-thumb:hover {
                      background: #a8a8a8;
                    }
                    .top-scrollbar {
                      scrollbar-width: thin;
                      scrollbar-color: #c1c1c1 #f1f1f1;
                    }
                  `}
                </style>
                <div 
                  ref={this.topScrollRef}
                  onScroll={this.handleTopScroll}
                  className="top-scrollbar"
                  style={{ 
                    overflowX: "auto", 
                    overflowY: "hidden",
                    width: "100%",
                    marginBottom: "5px"
                  }}
                >
                  <div style={{ height: "1px", minWidth: "1320px" }}></div>
                </div>
                <div 
                  ref={this.bottomScrollRef}
                  onScroll={this.handleBottomScroll}
                  style={{ overflowX: "auto", width: "100%" }}
                >
                  <table style={{ overflowY: "scroll", maxHeight: 300, minWidth: "1320px" }}>
                    <tr>
                      <th style={{width:100}}>Date of Session </th>
                      <th style={{width:130}}>ECAS Form Type</th>
                      <th style={{width:130}}>Langauge Score/Total</th>
                      <th style={{width:130}}>Verbal Fluency Score/Total</th>
                      <th style={{width:130}}>Executive Score/Total</th>
                      <th style={{width:130}}>Memory Score/Total</th>
                      <th style={{width:130}}>Visuospatial Score/Total</th>
                      <th style={{width:150}}>Total Score</th>
                      <th style={{width:150}}>Remark</th>
                      <th style={{width:130}}>Download ECAS Form</th>
                    </tr>
                    {this.state.all_forms &&
                      this.state.all_forms.map((item, index) => {
                        let form=this.isJSON(item.form_type)
                        let form_links=this.isJSON(item.ecas_form_link)
                        let form_type=''
                        if(form==true){
                          form_type=JSON.parse(item.form_type).join(',')
                        }else{
                          form_type=item.form_type;
                        }
                        let _single=false
                        let all_files=[]
                        if(form_links==true){
                          _single=false
                          all_files=JSON.parse(item.ecas_form_link)
                        }else{
                          _single=true
                          form_links=[item.ecas_form_link];
                        }
                        return (
                          <tr key={index}>
                            <td>
                              {item.form_submission_date ? item.form_submission_date : "---"}
                            </td>
                            <td>{form_type ? form_type : '---'}</td>
                            <td>{item.langauge_score ? item.langauge_score+'/28' : '0/28'}</td>                        
                            <td>{item.verbal_fluency_score ? item.verbal_fluency_score+'/24' : '0/24'}</td>                  
                            <td>{item.executive_score ? item.executive_score+'/48' : '0/48'}</td>                      
                            <td>{item.memory_score ? item.memory_score+'/24' : '0/24'}</td>              
                            <td>{item.visuospatial_score ? item.visuospatial_score+'/12' : '0/12'}</td>                     
                            <td>{item.total ? item.total+'/136' : '0/136'}</td>
                            <td>{item.remark ? item.remark : '---'}</td>
                            <td>
                              {item.type=='physical' && (
                                <>
                                  {_single==true ? (
                                    <button
                                      className="btn btn-primary mb-2"
                                      onClick={()=>this.view_file(item,_single,item.ecas_form_link)}
                                      style={{
                                        background: "#d06338",
                                        border: "1px solid #d06338",
                                      }}
                                    >
                                      <FaEye
                                        style={{ position: "relative", top: -2 }}
                                      />{" "}
                                      View
                                    </button>
                                  ):(
                                  <>
                                  {all_files.map((single_file,index)=>{
                                    return (
                                      <button
                                        key={index}
                                        className="btn btn-primary mb-2"
                                        onClick={()=>this.view_file(item,_single,single_file)}
                                        style={{
                                          background: "#d06338",
                                          border: "1px solidrgb(57, 52, 50)",
                                        }}
                                      >
                                        <FaEye
                                          style={{ position: "relative", top: -2 }}
                                        />{" "}
                                        View File {(index+1)}
                                      </button>   
                                    )
                                  })}
                                  </>
                                )}                      
                                </>
                              )}
                              {item.type=='form-a' && (
                                 <Link
                                  to={
                                    "/ecas-form-view-a?secret=" + item.ecas_forms_id
                                  }
                                  className="btn btn-primary"
                                  style={{
                                    background: "#d06338",
                                    border: "1px solid #d06338",
                                  }}
                                >
                                  <FaEye
                                    style={{ position: "relative", top: -2 }}
                                  />{" "}
                                  View
                                </Link>
                              )}
                              {item.type=='form-b'&& (
                                 <Link
                                  to={
                                    "/ecas-form-view-b?secret=" +
                                    item.ecas_form_b_id
                                  }
                                  className="btn btn-primary"
                                  style={{
                                    background: "#d06338",
                                    border: "1px solid #d06338",
                                  }}
                                >
                                  <FaEye
                                    style={{ position: "relative", top: -2 }}
                                  />{" "}
                                  View
                                </Link>
                              )}
                              {item.type=='form-c'&& (
                                 <Link
                                  to={
                                    "/ecas-form-view-c?secret=" +
                                    item.ecas_form_c_id
                                  }
                                  className="btn btn-primary"
                                  style={{
                                    background: "#d06338",
                                    border: "1px solid #d06338",
                                  }}
                                >
                                  <FaEye
                                    style={{ position: "relative", top: -2 }}
                                  />{" "}
                                  View
                                </Link>
                              )}                            
                            </td>
                          </tr>
                        );
                    })}
                    {this.state.all_forms.length == 0 && (
                      <tr>
                        <td colSpan={10} style={{ textAlign: "center" }}>
                          Not available..
                        </td>
                      </tr>
                    )}
                  </table>
                </div>
                <br />
                <div>
                  <p style={{ fontSize: 16 }}>
                    <i>
                      *Please note that changes in your scores do not
                      automatically indicate a change in cognitive function. For
                      an accurate evaluation, we recommend consulting with your
                      neurologist. The purpose of sharing this data with you is
                      to support our commitment to transparency and open access.
                      By providing participants in EverythingALS studies with
                      access to their data, we aim to empower you with the
                      information needed for you to stay informed and involved
                      in your healthcare decisions.
                    </i>
                  </p>
                </div>
                <br />
                <h5 class="pt-2 pb-3">
                  Frequently Asked Questions: Understanding your Score
                </h5>
                <Collapse
                  items={items}
                  defaultActiveKey={["1"]}
                  onChange={this.onChange}
                />
              </Spin>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
